<!-- 缺陷reopen -->
<template>
  <div>
    <a-row>
      <a-col :span="8">
        <a-card title="工单类型分布" size="small">
          <div id="ticket-tag" :style="{ height: height, width: width }" />
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card title="工单业务域分布" size="small">
          <div id="ticket-domain" :style="{ height: height, width: width }" />
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card title="AI结果分布" size="small">
          <div id="ticket-aiResult" :style="{ height: height, width: width }" />
        </a-card>
      </a-col>
    </a-row>
    <div v-if="tableData">
      <ticket-list-modal ref="ticketListModal" :task-list="tableData" :user-list="userList" :tag-list="tagList" />
    </div>
  </div>
</template>
<script>
import { getTicketPie, getTicketDomainPie, getAIResultPie } from '@/api/data/ticket';
import TicketListModal from '@/pages/data/ticket/components/TicketListModal';
import { ticketDomain, ticketAiResultPie } from '@/utils/dictionary';
export default {
  components: { TicketListModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    userList: {
      type: Array,
      default: null
    },
    tagList: {
      type: Array,
      default: null
    },
    height: {
      type: String,
      default: '360px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    taskMap: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      myDomainChart: null,
      myAiResultChart: null,
      modalVisible: false,
      ticketDomain,
      ticketAiResultPie,
      title: '',
      tableData: [],
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '任务名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' }
        }
      ],
      option: {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        series: [
          {
            name: null,
            type: 'pie',
            radius: '60%',
            center: ['50%', '58%'],
            data: [],
            label: {
              // formatter: '{b}: {@2012} ({d}%)',
              formatter: params => {
                return params.name + ': ' + params.value + ' (' + params.percent.toFixed(1) + '%)';
              }
            },
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    taskLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:event:ticket:detail',
          query: { ticketId: record.id }
        });
        return route.href;
      };
    }
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/pie'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    this.myChart = echarts.init(document.getElementById('ticket-tag'));
    this.myChart.on('click', params => {
      this.tableData = params.data.detail;
      this.modalVisible = true;
      this.title = params.data.name;
      this.$refs.ticketListModal.open();
    });
    this.myDomainChart = echarts.init(document.getElementById('ticket-domain'));
    this.myDomainChart.on('click', params => {
      this.tableData = params.data.detail;
      this.modalVisible = true;
      this.title = params.data.name;
      this.$refs.ticketListModal.open();
    });
    this.myAiResultChart = echarts.init(document.getElementById('ticket-aiResult'));
    this.myAiResultChart.on('click', params => {
      this.tableData = params.data.detail;
      this.modalVisible = true;
      this.title = params.data.name;
      this.$refs.ticketListModal.open();
    });
    // setTimeout(() => {
    //   this.getDiagramData();
    // }, 100); // 添加延迟
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    drawDomainChart() {
      this.myDomainChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myDomainChart.resize();
      });
    },
    drawAiPieChart() {
      this.myAiResultChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myAiResultChart.resize();
      });
    },
    getDiagramData() {
      getTicketPie(this.filterForm).then(res => {
        const pieData = Object.keys(res.data.ySerious).map(key => ({
          name: key,
          value: res.data.ySerious[key].length,
          detail: res.data.ySerious[key]
        }));
        this.option.series[0].data = pieData;
        this.drawChart();
      });
      getTicketDomainPie(this.filterForm).then(res => {
        const pieData = Object.keys(res.data.ySerious).map(key => ({
          name: ticketDomain[key].label,
          value: res.data.ySerious[key].length,
          detail: res.data.ySerious[key]
        }));
        this.option.series[0].data = pieData;
        this.drawDomainChart();
      });
      getAIResultPie(this.filterForm).then(res => {
        const pieData = Object.keys(res.data.ySerious)
          .filter(key => key !== '1')
          .map(key => ({
            name: ticketAiResultPie[key].label,
            value: res.data.ySerious[key].length,
            detail: res.data.ySerious[key]
          }));
        this.option.series[0].data = pieData;
        this.drawAiPieChart();
      });
    }
  }
};
</script>
